export default __webpack_public_path__ + "static/media/trylleby-property-12.e20df068.jpg";